// extracted by mini-css-extract-plugin
module.exports = {"filters":"styles-module__filters___pcz9s"};